import { ID, overdueSectionID, Task, TaskListTreeItem } from '@griply/types';

export const getOverdueTasksFromTree = (
  treeData: Record<ID, TaskListTreeItem>,
  tasksMap: Record<ID, Task>,
  overdueId: ID = overdueSectionID,
): Task[] => {
  const overdueSection = treeData[overdueId];
  if (!overdueSection?.children?.length) {
    return [];
  }

  return overdueSection.children
    .map((childId) => tasksMap[childId])
    .filter(Boolean) as Task[];
};
